module.exports = __webpack_public_path__ + "static/media/gegnerAnwalt.7c25f3c2.svg";